/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

// let sp_price1 = 49.99;
// let sp_price2 = 169.99;
// function calcTotal(price, num) {
//   let result = Number(price) * Number(num);
//   return result.toFixed(2);
// }

// $(".sp-reduce").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) - 1;
//   if (num > 0) {
//     input.value = num;
//   }
//   // $("#sp_price1").html(calcTotal(sp_price1, input.value));
//   // $("#sp_price2").html(calcTotal(sp_price2, input.value));
// });
// $(".sp-add").click(function () {
//   let input = $(this).siblings("input")[0];
//   let num = Number(input.value) + 1;
//   input.value = num;
//   // $("#sp_price1").html(calcTotal(sp_price1, input.value));
//   // $("#sp_price2").html(calcTotal(sp_price2, input.value));
// });
    $('#2').change(function () {
      var number = Number($('#2').val())
      let price = (number * Number(window.product[0].price / 100)).toFixed(2)
      let compare = (number * Number(window.product[0].compare_at_price / 100)).toFixed(2)
      let minus = (compare - price).toFixed(2)
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      minus = (minus + '').replace('.', ',')
      $(this)
        .parents()
        .parents()
        .siblings('.price-group')
        .children('.price1')
        .children('span')
        .html(price)
      $(this)
        .parents()
        .parents()
        .siblings('.price-group')
        .children('.price2')
        .children('span')
        .html(compare)
      
      $(this).parents('.sp-number').siblings('.price3').find('span').html(minus)
    })
    $('#3').change(function () {
      var number = Number($('#3').val())
      let price = (number * Number(window.product[1].price / 100)).toFixed(2)
      let compare = (number * Number(window.product[1].compare_at_price / 100)).toFixed(2)
      function truncatePrice(value) {
          return Math.floor(value * 100) / 100;
      }
      var minus = truncatePrice(price / 3).toFixed(2);
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      minus = (minus + '').replace('.', ',')
      $(this)
        .parents()
        .parents()
         .siblings('.price-group')
        .children('.price1')
         .children('span')
        .html(price)
      $(this)
        .parents()
        .parents()
          .siblings('.price-group')
        .children('.price2')
         .children('span')
        .html(compare)
      
      $(this).parents('.sp-number').siblings('.price3').find('span').html(minus)
    })
    $('#4').change(function () {
      var number = Number($('#4').val())
      let price = (number * Number(window.product[2].price / 100)).toFixed(2)
      let compare = (number * Number(window.product[2].compare_at_price / 100)).toFixed(2)
      function truncatePrice(value) {
          return Math.floor(value * 100) / 100;
      }
      var minus = truncatePrice(price / 5).toFixed(2);
      price = (price + '').replace('.', ',')
      compare = (compare + '').replace('.', ',')
      minus = (minus + '').replace('.', ',')
      $(this)
        .parents()
        .parents()
         .siblings('.price-group')
        .children('.price1')
         .children('span')
        .html(price)
      $(this)
        .parents()
        .parents()
         .siblings('.price-group')
        .children('.price2')
         .children('span')
        .html(compare)
      
      $(this).parents('.sp-number').siblings('.price3').find('span').html(minus)
    })
    // 数字框初始化
    alignmentFns.initialize()
  $('.link-btn').click(function(){
    let num = $(this).siblings('.sp-number').find('input').val()
    let id = $(this).attr('data-id')
    window.location.href = '/cart/' + id + ':' + num
  })
let spImgList = [];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            249 * $("div#root").css("zoom") -
            156 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

let _isShow = false;
$("#spmore").click(function () {
  if (_isShow) {
    $(this).addClass("sp-show");
    $(".sp-content").css("height", "auto");
  } else {
    $(this).removeClass("sp-show");
    $(".sp-content").css("height", "0px");
  }
  _isShow = !_isShow;
});
